var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"head",attrs:{"align":"left"}},[_vm._v(_vm._s(_vm.name))]),_c('td',{attrs:{"align":"left"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }